<template>
	<div>
		<reporthead :isborder="false" :rightshow="false" title="浏览内容明细"></reporthead>
		<!--  -->
		<div class="det_content">
			<cinformation :detail="Details_data"></cinformation>
			<div class="databoxs">
				<div class="tit">
					数据表现
				</div>
				<cresentation  :list="sentlist"></cresentation>
			</div>
		</div>
		<!--  -->
		<!--  -->
		<div class="table_box " v-loading="table_loading" v-show="!table_loading">
			<!--  -->
			<tabcontainer  :surplus="550" :ischecks="false" :list.sync="datapage.list"
				:total.sync="datapage.total" :pagesize.sync="datapage.pagesize" :page.sync="datapage.page"
				@retucheck="(e)=>{check_list = e.val}" @changesize="modify_pagesize" @changepage="switch_page">
				<!--  -->
				<template slot="body">
					<!--  -->
					<el-table-column :width="item.width" :prop="item.prop" :label="item.name" v-for="(item, index) in tableColumn">
					</el-table-column>
					<!--  -->
				</template>
				<!--  -->
			</tabcontainer>
			<!--  -->
		</div>
		<!--  -->
	</div>
</template>

<script>
	
	import {
		get_report_data,
		get_report_details,
		get_record,
		getSecondTime,
	}  from "../js/report.js"
	import reporthead from "../components/reporthead.vue"
	import cinformation from "../components/cinformation.vue"
	import cresentation from "../components/cresentation.vue"
	import tabcontainer from "../components/tabcontainer.vue";
	export default {
		components: {
			reporthead,
			cinformation,
			cresentation,
			tabcontainer,
		},
		created() {
			let {res} = this.$route.query
			this.Details_res = res
			this.get_Details()
			this.getdatalist()
		},
		methods: {
			get_Details(){
				let {
					content_type,content_id,member_id
				} = this.Details_res
				let data = {
					content_type,  // 	是	int	//1:名片2:文章3:产品4:表单5:素材
					content_id,  // 	是	int	内容id
					member_id,  // 	是	int	成员id
				}
				get_report_data(data).then(res=>{
					if(!res) return
					if(res.result) {
						let obj = res.result
						if(obj) {
							get_record(obj)
							this.Details_data = obj
							for(let i =0;i < this.sentlist.length; i++) {
								let val = 0
								if(i == 0) {
									val = obj.visit_num
								}
								else if(i == 1) {
									val = obj.cuepool_num
								}
								else if(i == 2) {
									val = obj.customer_num
								}
								else if(i == 3) {
									val = getSecondTime(obj.visit_time * 1)
								}
								else if(i == 4) {
									val = obj.jump_rate ? obj.jump_rate + '%' : '0%';
								}
								this.sentlist[i].num = val
							}
						}
						else {
							if(this.Details_res) {
								this.Details_data = {
									name: this.Details_res.content_title || '',
									file_url: this.Details_res.file_url || '',
									icon: this.Details_res.icon || '',
								}
							}
						}	
					}
					else {
						this.$router.go(-1) 
						this.$alertMess('暂无数据','error')
					}
				})
			},
			getdatalist(){
				this.table_loading = true 
				let {
					content_type,content_id,member_id
				} = this.Details_res
				let data = {
					pagesize: this.datapage.pagesize, //  	是	int	每页数量
					page: this.datapage.page,
					content_type,  //	是	int	//1:名片2:文章3:产品4:表单5:素材
					content_id,  //	是	int	内容id
					member_id,  //	是	int	成员id
				}
				get_report_details(data).then(res=>{
					if(!res) return
					let obj = res.result.data
					this.handle_data(obj)
					this.datapage.total = res.result.total
					this.table_loading = false	
				})
			},
			// 处理数据
			handle_data(data) {
				if (!data) return
				for (let item of data) {
					item.second_txt = getSecondTime(item.visit_time * 1)
					item.visit_count = `第${item.visit_count}次`
				}
				this.datapage.list = data
			},
			//
			modify_pagesize(e) {
				let {
					val
				} = e
				this.datapage.page = 1
				this.datapage.pagesize = val
				this.getdatalist()
			},
			switch_page(e) {
				let {
					val
				} = e
				this.datapage.page = val
				this.getdatalist()
			},
		},
		data() {
			return {
				Details_data: {},
				sentlist: [{
						title: '浏览量',
						num: 0,
					},
					{
						title: '线索量',
						num: 0,
					},
					{
						title: '意向客户',
						num: 0,
					},
					{
						title: '浏览时长',
						num: 0,
					},
					{
						title: '5S跳出率',
						num: '0%',
					},
				],

				table_loading: false,
				tableColumn: [
					
					{
						prop: 'wx_name',
						name: '浏览人',
					},
					{
						prop: 'start_time',
						name: '浏览时间',
					},
					{
						prop: 'second_txt',
						name: '浏览时长',
					},
					{
						prop: 'visit_count',
						name: '浏览次数',
					},
				],
				// ------------------  
				datapage: {
					pagesize: 20,
					page: 1,
					total: 0,
					list: [],
				},
				check_list: [],
				// ------------------
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import "../css/report.scss";
</style>
